import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

/**
 * MobileSlider - Wrapper component that converts grid layouts to swipeable sliders on mobile
 * On desktop: renders children as normal (grid layout preserved)
 * On mobile: converts to horizontal scrollable slider with snap points
 */
const MobileSlider = ({ children, spacing = 3 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isMobile) {
    // Desktop: render children normally (grid layout)
    return <>{children}</>;
  }

  // Mobile: convert to horizontal slider
  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'visible',
        gap: spacing,
        pb: 2,
        px: 0.5,
        // Snap scrolling
        scrollSnapType: 'x mandatory',
        scrollBehavior: 'smooth',
        // Hide scrollbar but keep functionality
        '&::-webkit-scrollbar': {
          height: '6px'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D4AF37',
          borderRadius: '10px',
          '&:hover': {
            backgroundColor: '#b8941f'
          }
        },
        // Touch scrolling optimization
        WebkitOverflowScrolling: 'touch',
        // Allow both horizontal and vertical scroll
        touchAction: 'auto'
      }}
    >
      {React.Children.map(children, (child, index) => (
        <Box
          key={index}
          sx={{
            // Each card takes 85% of viewport width
            minWidth: '85vw',
            maxWidth: '85vw',
            // Snap to center
            scrollSnapAlign: 'center',
            scrollSnapStop: 'always',
            // Ensure card doesn't shrink
            flexShrink: 0
          }}
        >
          {child}
        </Box>
      ))}
    </Box>
  );
};

export default MobileSlider;
